
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useContents from "customHooks/useContents";
import useHeaderTitleSetter from "customHooks/useHeaderTitleSetter";
import useMobile from "customHooks/useMobile";
import StaticLayout from "layout/StaticLayout";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { AboutLayoutProps } from "pages/about";
import { getStaticPagesLayoutData } from "ssrUtils";
const PrivacyPolicy: React.FC<AboutLayoutProps> = ({ pages }) => {
    const conts = useContents();
    const { locale } = useRouter();
    // const privServer = pages.find((page) => page.slug === "privacy");
    const priv = conts?.data?.pages?.find((page) => page.slug === "privacy")?.contents;
    const { t } = useTranslation("common");
    const privBody = priv?.body?.[locale];
    // const title = privServer?.[locale];
    useHeaderTitleSetter({ title: t("privacy_policy"), section: "" });
    const isMobile = useMobile("md");
    return (<div className={isMobile && "container px-4 mt-3"}>
      <div className="mt-4 about-child" dangerouslySetInnerHTML={{ __html: privBody }}/>
    </div>);
};
export default PrivacyPolicy;
(PrivacyPolicy as any).Layout = StaticLayout;
const getStaticProps = getStaticPagesLayoutData;

    async function __Next_Translate__getStaticProps__1a13f66bef6__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/help/privacy',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66bef6__ as getStaticProps }
  